import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { mobileValidationSchema, verifyOTPValidationSchema } from './ValidationSchema';
import { getLoginWithOtp, verifyLogin } from '../asiosConfig';
import { toast, ToastContainer } from 'react-toastify';
import Footer from './Footer';
import { Box, Button, TextField } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';

export const LoginWithOtp = () => {
    const [step, setStep] = useState(1);
    const [resending, setResending] = useState(false); // State to handle resend OTP
    const [timer, setTimer] = useState(0);
    const navigate = useNavigate();

    useEffect(() => {
        let countdown;
        if (timer > 0) {
            countdown = setInterval(() => {
                setTimer(prevTimer => prevTimer - 1);
            }, 1000);
        }
        return () => clearInterval(countdown);
    }, [timer]);

    const formik = useFormik({
        initialValues: {
            username: '',
            otp: '',
        },
        validationSchema: step === 1 ? mobileValidationSchema : verifyOTPValidationSchema,
        onSubmit: async (values, { setSubmitting }) => {
            try {
                if (step === 1) {
                    const response = await getLoginWithOtp({ username: values.username });

                    if (response.status === 200) {
                        toast.success(response.data.message);
                        setStep(2);
                    } else {
                        toast.error(response.data.message);
                    }
                } else if (step === 2) {
                    const response = await verifyLogin({ mobile_number: values.username, otp: values.otp, active_device: 'web' });

                    if (response.status === 200 || response.status === 201) {
                        localStorage.setItem('token', response.data.token);
                        localStorage.setItem('user', JSON.stringify(response.data.user || {}));
                        localStorage.setItem('user_name', response.data.user_name || '');
                        localStorage.setItem('last_complete_step', response.data.last_complete_step || '');
                        localStorage.setItem('profilePhoto', response.data.photo || '');
                        localStorage.setItem('gender', response.data.gender);
                        localStorage.setItem('account_type', response.data.account_type || '');
                        if (response.data.is_verified === 0 || response.data.is_verified === null) {
                            navigate('/phone-verification-otp');
                            window.location.reload();
                        } else {
                            navigate('/my_matches');
                            window.location.reload();
                        }
                        localStorage.setItem('is_verified', response.data.is_verified);
                        toast.success(response.data.message);
                    } else {
                        toast.error(response.data.message);
                    }
                }
            } catch (error) {
                toast.error(error.response.data.message);
            } finally {
                setSubmitting(false);
            }
        },
    });

    const handleResendOtp = async () => {
        setResending(true);
        try {
            const response = await getLoginWithOtp({ username: formik.values.username });

            if (response.status === 200) {
                toast.success('OTP has been resent successfully.');
                setTimer(60);
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error('Failed to resend OTP.');
        } finally {
            setResending(false);
        }
    };

    return (
        <>
            <div className="fixed-top loginTopBG">
                <div className="container d-flex justify-content-between align-items-between">
                    <div className="logo">
                        <a href="#"
                        ><img src="images/logo.png" className="img-fluid" alt="logo-img"
                            /></a>
                    </div>
                    <div className="accountBtn">
                        <a href="/login" className="btn loginBtn">LOGIN</a>
                        <Link to="/" className="btn regBtn">REGISTER</Link>
                    </div>
                </div>
            </div>
            <section className='formBG mt-5'>
                <div className='container'>
                    <div className="formContent">
                        <h2>LOGIN WITH OTP</h2>
                        <form onSubmit={formik.handleSubmit}>
                            <div className='row justify-content-center align-items-center'>
                                <div className="col-md-5">
                                    <div className="otpBG">
                                        {step === 1 ? (
                                            <>
                                                <div className="mb-3">
                                                    <label className='form-label'>Enter Mobile Number</label>
                                                    <TextField
                                                        name="username"
                                                        label="Enter Mobile Number"
                                                        type="tel"  // Better for phone numbers
                                                        variant="outlined"
                                                        fullWidth
                                                        placeholder="Enter Mobile Number"
                                                        size='small'
                                                        value={formik.values.username}
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            // Allow only numbers and limit to 10 digits
                                                            if (/^\d*$/.test(value) && value.length <= 10) {
                                                                formik.handleChange(e);
                                                            }
                                                        }}
                                                        onKeyPress={(e) => {
                                                            // Block non-numeric key presses
                                                            if (!/[0-9]/.test(e.key)) {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        inputProps={{
                                                            maxLength: 10,  // Strictly enforce 10 digits
                                                        }}
                                                        onBlur={formik.handleBlur}
                                                        error={formik.touched.username && Boolean(formik.errors.username)}
                                                        helperText={formik.touched.username && formik.errors.username}
                                                    />
                                                </div>
                                                <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
                                                    <Button type="button" variant="outlined" color="primary" onClick={() => navigate(-1)} >
                                                        Cancel
                                                    </Button>
                                                    <Button type="submit" variant="contained" color="primary" disabled={formik.isSubmitting} className="btn btn-primary btnCancel">
                                                        Submit
                                                    </Button>
                                                </Box>
                                            </>
                                        ) : (
                                            <>
                                                <div className="mb-3">
                                                    <label className='form-label'>Enter Mobile Number</label>
                                                    <TextField
                                                        name="username"
                                                        label="Enter Mobile Number"
                                                        type="text"
                                                        variant="outlined"
                                                        size='small'
                                                        fullWidth
                                                        placeholder="Enter Mobile Number"
                                                        disabled
                                                        value={formik.values.username}
                                                    />
                                                </div>
                                                <div className="mb-3">
                                                    <label className='form-label'>Enter OTP</label>
                                                    <TextField
                                                        name="otp"
                                                        label="Enter OTP"
                                                        type="text"
                                                        variant="outlined"
                                                        fullWidth
                                                        placeholder="OTP"
                                                        value={formik.values.otp}
                                                        size='small'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        error={formik.touched.otp && Boolean(formik.errors.otp)}
                                                        helperText={formik.touched.otp && formik.errors.otp}
                                                    />
                                                </div>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <p className="recTxt">Didn't receive OTP?</p>
                                                    <p
                                                        className="resendTxt"
                                                        onClick={timer === 0 ? handleResendOtp : null}
                                                        style={{
                                                            cursor: timer === 0 ? 'pointer' : 'not-allowed',
                                                            color: timer === 0 ? 'red' : 'grey',
                                                        }}
                                                    >
                                                        {timer > 0 ? `Resend OTP in ${timer}s` : 'Resend OTP'}
                                                    </p>
                                                </div>
                                                <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
                                                    <Button type="button" variant="outlined" color="primary" onClick={() => navigate(-1)} >
                                                        Cancel
                                                    </Button>
                                                    <Button type="submit" variant="contained" color="primary" disabled={formik.isSubmitting} className="btn btn-primary btnCancel">
                                                        Confirm
                                                    </Button>
                                                </Box>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
            <ToastContainer />
            <Footer />
        </>
    );
};
